import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 2.5H4.005a1 1 0 0 0 0 1.998h9.997A1 1 0 1 0 14 2.5M2.005 3.499a1 1 0 0 0-2 0 1 1 0 0 0 0 .195.9.9 0 0 0 .15.36.9.9 0 0 0 .275.274q.08.058.17.095.1.052.21.075.097.012.195 0a1 1 0 0 0 .925-.614 1 1 0 0 0 .075-.19 1 1 0 0 0 0-.195M2.005 7.997a1 1 0 0 0 0-.195.8.8 0 0 0-.075-.185 1 1 0 0 0-.22-.325 1 1 0 0 0-1.54 1.26 1 1 0 0 0 .13.15.7.7 0 0 0 .15.125.85.85 0 0 0 .36.15 1 1 0 0 0 .195.02q.097.01.195 0a.8.8 0 0 0 .185-.055 1 1 0 0 0 .175-.095.7.7 0 0 0 .15-.125.7.7 0 0 0 .125-.15.8.8 0 0 0 .095-.17.9.9 0 0 0 .075-.21.8.8 0 0 0 0-.195M2.005 12.496a1 1 0 0 0 0-.195 1 1 0 0 0-.075-.19 1 1 0 0 0-.095-.17 1 1 0 0 0-1.66 0q-.054.08-.095.17a.8.8 0 0 0-.055.19 1 1 0 0 0 .275.9q.068.072.15.124.08.058.17.095.092.039.19.055.097.022.195.02.097.012.195 0a.8.8 0 0 0 .185-.055.8.8 0 0 0 .175-.095.7.7 0 0 0 .15-.125.7.7 0 0 0 .125-.15.8.8 0 0 0 .095-.17.9.9 0 0 0 .075-.21 1 1 0 0 0 0-.194M15 6.998H4.004a1 1 0 0 0 0 1.999H15a1 1 0 0 0 0-2M10.502 11.496H4.004a1 1 0 1 0 0 2h6.498a1 1 0 0 0 0-2"
    }, null, -1)
  ]))]))
}
export default { render: render }